import { render, staticRenderFns } from "./JcomTableBoardMembersList.vue?vue&type=template&id=8aa83d62"
import script from "./JcomTableBoardMembersList.vue?vue&type=script&lang=js"
export * from "./JcomTableBoardMembersList.vue?vue&type=script&lang=js"
import style0 from "./JcomTableBoardMembersList.vue?vue&type=style&index=0&id=8aa83d62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports